import { collection } from 'typesaurus';
export const snippets = collection('snippets');
